import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/qrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-39515751"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "r_header_content" }
const _hoisted_2 = { id: "r_header_right" }
const _hoisted_3 = {
  class: "page_title",
  "data-aos": "fade-down",
  "data-aos-duration": "800"
}
const _hoisted_4 = {
  id: "r_tabs",
  "data-aos": "fade-right",
  "data-aos-duration": "800",
  "data-aos-delay": "200"
}
const _hoisted_5 = ["onMouseup", "id"]
const _hoisted_6 = {
  id: "r_tab_content",
  "data-aos": "fade-up",
  "data-aos-duration": "800",
  "data-aos-delay": "400"
}
const _hoisted_7 = {
  id: "p_qrcode",
  "data-aos": "zoom-in",
  "data-aos-duration": "800",
  "data-aos-delay": "300"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "p_qrcode_img",
  src: _imports_0
}, null, -1))
const _hoisted_9 = { id: "p_qrcode_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `tab_${index}`,
            onMouseup: ($event: any) => (_ctx.handleTab(index)),
            id: _ctx.selectedIndex == index ? 'r_tab_selected' : 'r_tab_normal'
          }, _toDisplayString(tab.title), 41, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.tabs[_ctx.selectedIndex].des), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.qrCodeTips), 1)
    ])
  ]))
}